import { render, staticRenderFns } from "./AllergyList.vue?vue&type=template&id=069c9db6&scoped=true"
import script from "./AllergyList.vue?vue&type=script&lang=js"
export * from "./AllergyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c9db6",
  null
  
)

export default component.exports